import { render, staticRenderFns } from "./SelectVat.vue?vue&type=template&id=06bab4b4&"
import script from "./SelectVat.vue?vue&type=script&lang=ts&"
export * from "./SelectVat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports